import { USER_TYPE } from 'app/ducks/auth/types'

// Seeded (off) by amsm-backend's
// hall/feature_flags/migrations/0007_seed_internal_campaigns_flag.py.
export const INTERNAL_CAMPAIGNS_FLAG = 'internal_campaigns'

// Collaborator and above — the same audience the backend enforces
// (`has_minimum_access_level(UserType.COLLABORATOR)`, which includes
// biometry_manager at the same level).
export const INTERNAL_CAMPAIGN_ROLES = [
  USER_TYPE.COLLABORATOR,
  USER_TYPE.BIOMETRY_MANAGER,
  USER_TYPE.FINANCIAL,
  USER_TYPE.MANAGER,
  USER_TYPE.ADMINISTRATOR,
]

export const INTERNAL_CAMPAIGNS_PATH = '/novidades'

// How many campaign popups a user sees per page load; the rest wait on the
// Novidades page (and its badge) instead of stacking up after login.
export const MAX_POPUPS_PER_SESSION = 3

export const CAMPAIGN_KIND_LABELS = {
  new_feature: 'Nova funcionalidade',
  announcement: 'Comunicado',
  tip: 'Dica',
}

export const isExternalUrl = (url) => /^https?:\/\//i.test(url || '')
